<template>
  <header class="c-header">
    <div class="c-img" :style="{backgroundImage: `url('${ikUrl}')`}"/>
    <div class="c-tint"/>
    <div class="container">
      <div class="row">
        <div class="col-lg-10">
          <h1 class="c-heading flex-container justify-start align-items-center">
            <span class="c-label flex-item">collection</span>
            <span class="c-name flex-item">{{ name }}</span>
          </h1>

          <div :class="{'expandable': true, 'expanded': descExpanded}">
            <slot name="description"/>
          </div>
          <div class="expand-toggle"><a
            role="button"
            @click="toggleExpanded">{{ descExpanded ? 'Collapse' : 'Expand to Read More' }} <i class="fa fa-angle-down gbm-animated-icon" :class="{'gbm-animated-icon--upside-down': descExpanded }"/></a></div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { urlFromAWSUrl } from '@/imagekit/imageurl_from_aws_url'

export default {
  name: 'PageHeader',
  props: {
    uuid: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      descExpanded: false
    }
  },
  computed: {
    ikUrl() {
      return urlFromAWSUrl(this.imageUrl, [{ width: 800, height: 800, crop: 'at_max' }])
    }
  },
  methods: {
    toggleExpanded() {
      this.descExpanded = !this.descExpanded
      if (this.descExpanded) {
        this.$sendEvent('Expanded Collection Description')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';
@import '~@/mixins.less';

.c-header {
  position: relative;
  color: white;

  .c-img {
    .bg-full;
    .bg-image;
    z-index: -2;
  }

  .c-tint {
    .bg-full;
    background: rgba(0, 0, 0, 0.65);
    z-index: -1;
  }

  .c-heading {
    font-size: 2.25rem;
    line-height: 1.15;
    margin-top: 1em;
    margin-bottom: 0.75em;

    .c-label {
      padding: 0.4em;
      background: @gb_orange_dark;
      text-transform: uppercase;
      font-size: 0.55em;
      margin-right: 1em;
    }
    .c-name {
      flex: 1 1;
    }
  }
}
.expandable {
  max-height: 64px;
  transition: 0.3s max-height;
  overflow: hidden;
  &.expanded {
    max-height: 500px;
  }
}
.expand-toggle {
  font-weight: 500;
  font-size: 1.31em;
  padding: 0.5em 0 1.5em 0;
}
</style>

<style lang="less">
.c-header {
  a {
    color: white;
    text-decoration: underline;
    &:link,
    &:visited,
    &:active {
      color: white;
      text-decoration: underline;
    }
    &:hover {
      color: #ccc;
    }
  }
}
</style>
